<template>
    <div v-if="currentMetal">
        <h1 class="font-active mb-3">{{currentCarat.product_name}}</h1>

        <div class="my-4">
            <div class="price_box my-4 pb-md-3">
                <div class="price_igi">
                    <h2 class="">
                        {{ $formatPrice(currentCarat.price) }}
                        <span class="ms-2" v-if="!$country.is_india && currentCarat.discount_label">{{ $formatPrice(currentCarat.mrp) }}</span>
                        <!-- <div class="disc_chip_pdp" v-if="!$country.is_india">{{ currentCarat.discount_label }}% OFF</div>
                        <p v-if="!$country.is_india" class="d-md-block lowest_price_pdp">Lowest Price Ever</p> -->
                    </h2>
                    <div class="igi_block" v-if="['IGI', 'igi'].includes(detailData.lab)">
                        <img width="30" height="30" src="https://assets.friendlydiamonds.com/fdl/fd_gif/diamond.gif" alt="">
                        <span>IGI Certified</span>
                    </div>
                </div>
                
                <div class="d-flex mt-2 w-100">
                    <div v-if="!$country.is_india && currentCarat.discount_label" class="disc_chip_pdp">{{ currentCarat.discount_label }}% OFF</div>                
                    <p v-if="!$country.is_india && currentCarat.lowest_price_label && currentCarat.discount_label" class="lowest_price_pdp">Lowest Price Ever</p>
                </div> 

                <div class="affirm_info" v-if="$country.affirm">
                    <p class="affirm-as-low-as mb-0 mt-2" data-page-type="diamond" :data-amount="currentCarat.price * 100"></p>
                </div>
            </div>


            <div class="mb-3 mt-3 "  v-if="$country.expedite">
                <CommonChristmasExpediteDelivery :locale="$i18n.locale" />
            </div>

            <div class="mt-4">
                     
                <JewelryWebShopMetalCarat 
                    v-if="!isFastShip"
                    :type="'metal'" 
                    :label="'Metal'" 
                    attr="metal"
                />

                <JewelryWebShopMetalCarat 
                    v-if="!isFastShip && !['couple-bands-ring', 'band-ring'].includes(detailData.sub_type)" 
                    :type="'carat'" 
                    :label="'Choose Total Carat Weight'" 
                    attr="carat"
                />
                
                <JewelryWebshopDropdown 
                    v-if="['full-eternity-ring', 'band-ring', 'anniversary-ring', 'toi-et-moi-ring','engagement-ring'].includes(detailData.sub_type)" 
                    :type="'size'" 
                    attr="size"
                    :label="'select ring size ('+sizeSelectCountry+')'" 
                    :mode="errors.size"
                    ref="viewerror"
                    :fastShip="true"
                />

                <JewelryWebshopDropdown 
                    v-if="detailData.sub_type === 'stud-earring' || 'fashion-earring'" 
                    :type="'size'" 
                    :label="'back type'" 
                    attr="back_type"
                    :mode="errors.back_type"
                    :fastShip="true"
                    ref="viewerror"
                />
                     
                <JewelryWebshopDropdown 
                    v-if="['tennis-necklace', 'solitaire-necklace'].includes(detailData.sub_type)" 
                    :type="'size'" 
                    attr="chain_length"
                    :label="'chain length'"
                    :mode="errors.chain_length" 
                    :fastShip="true"
                    ref="viewerror"
                />

                <JewelryWebshopDropdown 
                    v-if="['tennis-bracelet'].includes(detailData.sub_type)" 
                    :type="'size'" 
                    attr="chain_length"
                    :label="'Bracelet length'"
                    ref="viewerror"
                    :mode="errors.chain_length" 
                />
                <div class="row" v-if="['couple-bands-ring'].includes(detailData.sub_type)">
                    <div class="col-lg-6">
                        <JewelryWebshopDropdown 
                            :type="'her_size'" 
                            attr="her_size"
                            :label="'her size ('+sizeSelectCountry+')'"
                            :mode="errors.her_size"
                            ref="viewerror"
                            />
                    </div>
                    <div class="col-lg-6">
                        <JewelryWebshopDropdown 
                            ref="viewerror"
                            :type="'size'" 
                            attr="his_size"
                            :label="'his size ('+sizeSelectCountry+')'" 
                            :mode="errors.his_size"
                            />
                    </div>
                </div>
                
                <div v-if="isFastShip">
                   
                        <div>
                            <JewelryWebshopMetalDropdown
                                v-if="detailData.sub_type === 'hoop-earring' "
                                :type="'metal'"
                                attr="metal_carat" 
                                :label="'Choose Metal and Carat '" 
                            />
                            <JewelryWebshopMetalDropdown
                                v-if="isSizeSelected && detailData.sub_type != 'hoop-earring' "
                                :type="'metal'"
                                attr="metal_carat" 
                                :label="'Choose Metal and Carat '" 
                            />
                        </div>
                        <div>
                            <div v-if="!isSizeSelected && detailData.sub_type != 'hoop-earring'" class="proceed_msg mb-4">
                                <label class="mb-0">Choose Metal and Carat</label>
                                <div class="please_select">
                                    <span>Please Select Size </span>
                                    <SvgHeaderSvg :type="'down'" />
                                </div>
                            </div>
                        </div>
                   
                </div>
            </div>

            <div v-if="$country.appraisal">
                <div class="check_band" v-if="currentMetal && detailData.sub_type != 'couple-bands-ring'">
                    <div class="checkbox_custom ms-0" id="appraisal">
                        <div class="checkbox_custom_labels" @click="toggleAppraisal()">
                            <span :class="{ 'checked' : has_appraisal === 1,  'unchecked' : has_appraisal === 0 }"></span>
                            <label class="mb-0">Add an Appraisal Certificate (+ {{ $formatPrice(50) }}) </label>
                        </div>
                        <div class="tooltip_box">
                            <SvgHeaderSvg class="ms-1" :type="'info'" />
                            <div class="tooltip_text tooltip_text_mod">This document is usually required to apply for your {{ $t('jewelry') }} insurance after you recieve the item</div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="my-4">
                <CommonEstimateDate :module_subtype="'shop'" :setting_id="currentCarat.id" :diamond_id="''" :size="currentActiveSize.value"/>
            </div>

            <div class="my-4">
                <div class="quicker" v-if="!isFastShip && hasInstockItem">
                    <p class="mb-0">Need it Quicker? Checkout our <span @click="redirectQuickShip(true)">QuickShip</span> products</p>
                </div>
                <div class="quicker" v-else-if="isFastShip">
                    <p class="mb-0">Want more choices? Dive into our <span @click="redirectQuickShip(false)">Full Catalog</span></p>
                </div>
            </div>
            <div class="select_button" v-if="loader">
                <span>Please wait...</span>
            </div>
            <div v-else class="select_btn_block">

                <div class="alert alert-info mb-0" role="alert" v-if="currentMetal.availability === 0 || currentCarat.availability === 0">
                    *This item is no longer available
                </div>

                <div class="select_button" v-if="buttonLoader">
                    <span>PLEASE WAIT...</span>
                </div>

                <div v-else @click="addToCart()" class="select_button">
                    <div>add to bag</div>
                </div>

            </div>

            <div class="row my-4">

                <div class="col-lg-6 col-md-12 mb-3">
                    <ModalDropHint :data="detailData" />
                </div>

                <div class="col-lg-6 col-md-12 mb-3">
                    <ModalGemologist :data="detailData" />
                </div>

                <div class="col-12 mb-3">
                    <CommonFreeCartOffer v-if="$country.free_product" class="mt-2" />
                </div>

            </div>

        </div>
    </div>
</template>

<script setup>
    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()
    const viewerror = ref(null);
    const localePath = useLocalePath();
    const { $country, $formatPrice, $toast, $jewelryDetailGtag, $jewelryToCartGtag } = useNuxtApp()

    const route = useRoute()
    const router = useRouter()
    
    const has_appraisal = ref(0)
    const errors = ref({})
    const skeleton = ref(true)
    const buttonLoader = ref(false)
    const loader = ref(true)

    const currentActiveSize = computed(() => {
        const size = store.getCurrentActive('size')
        if(size){
            return size
        }
        return ''
    })

    const sizeSelectCountry = computed(() => {
        if($country.is_india){
            return 'IN'
        }
        return 'US'
    })

    const detailData = computed(() => {
        return store.getDetailData
    }) 

    const currentMetal = computed(() => {
        return store.getCurrentActive('metal')
    })

    const currentCarat = computed(() => {
        const item = store.getCurrentActive('carat')
        
        if( import.meta.client && item !== null && window.affirm !== undefined ){
            nextTick(() => {
                window.affirm.ui.ready(() => {
                    window.affirm.ui.refresh();
                });
            });
        }
        if(import.meta.client && item !== null){
            $jewelryDetailGtag({ metal: currentMetal.value, carat: item })
        }
        return item 
    }) 

    const isSizeSelected = computed(() => {
        return store.getCurrentActive( 'size' )
    })

    const isFastShip = computed(() => {
            const query = route.query
            // console.log(route.query, 'route.query')
            if(Object.keys(query).length > 0){
                if([false, 'false'].includes(route.query.FastShip)){
                    return false
                }
                if([true, 'true'].includes(route.query.FastShip)){
                    return true
                }
            }
            return false
        })

    const hasInstockItem = computed(() => {
        const data = store.getInStockData('')
        return data.length > 0 
    })


    function redirectQuickShip( toFastShip ){
                
        const currentRoute = route;
        
        // Construct the new query parameters object
        const query = { ...route.query };
        currentRoute.query['FastShip'] = toFastShip;
        
        // const newRoute = { ...currentRoute, query };
        // console.log( currentRoute.fullPath+'?FastShip='+toFastShip,'12345')
        // // Push the new route, causing a remount of the page
        window.location.href = localePath({path: currentRoute.fullPath, query:{'FastShip': toFastShip}})
        //  return router.push(localePath({path: currentRoute.fullPath, query:{'FastShip': toFastShip}}))
    }
  

    const scrollToError = async () => {
        await nextTick();
        if (viewerror.value) {
            const dropdownEl = viewerror.value.$el || viewerror.value;
            dropdownEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    const addToCart = async () => {
            errors.value = {};
            
            let data = {
                item_id: store.getCurrentActive('carat')?.id,
                item_type: detailData.value.sub_type,
                has_appraisal: has_appraisal.value,
            };
           
            let errorObj = {
                size: ['Please select the size to proceed.'],
                her_size: ['Please select her size to proceed.'],
                his_size: ['Please select his size to proceed.'],
                back_type: ['Please select the back type to proceed.']
            };
            const subtype = store.getProductSubtype('');
            data[subtype] = store.getCurrentActive('size')?.value;

            

            if (detailData.value.sub_type === 'couple-bands-ring') {
                data.her_size = store.getCurrentActive('her_size')?.value;
                data.his_size = store.getCurrentActive('size')?.value;

                if (!data.her_size && !data.his_size) {
                errors.value.her_size = ['Please select her size to proceed.'];
                errors.value.his_size = ['Please select his size to proceed.'];
                await scrollToError(); 
                return;
            }
            if (!data.her_size) {
                errors.value.her_size = ['Please select her size to proceed.'];
                await scrollToError(); 
                return;
            }
            if (!data.his_size) {
                errors.value.his_size = ['Please select his size to proceed.'];
                await scrollToError(); 
                return;
            }
            
            } else if (detailData.value.sub_type === 'hoop-earring' || 'fashion-bracelet') {
                // Handle other validations if needed
            } 
            
            else {
                if (!data[subtype]) {
                    errors.value = errorObj;
                    await scrollToError(); 
                    return;
            }
        }

    // Actual API call
    try {
        buttonLoader.value = true;
        const res = await $fetch(useCountryPath("/shop/add/session"), {
            method: 'POST',
            body: data
        });
        if (res.success) {
            
            $jewelryToCartGtag({ metal: currentMetal.value, carat: currentCarat.value });
            $toast('success', 'Congratulations!', 'Item added to cart.');
            setTimeout(() => {
                window.location.href = localePath({ path: '/cart' });
                // this.$router.push(this.localePath('/cart')); 
                // this.$store.dispatch('getCartCount');
            }, 1500);
            buttonLoader.value = false;
        }

    } catch (error) {
        buttonLoader.value = false;
        if (error.status === 422) {
            errors.value = error.data.errors;
            await scrollToError(); 
        }
        if (error.status === 400) {
            $toast('alert', 'Alert!', 'The cart cannot accommodate more than 10 products.');
        }
    }
};

            
    function toggleAppraisal(){
        if(has_appraisal.value === 0){
            has_appraisal.value = 1
        }else{
            has_appraisal.value = 0
        }
    }

    onMounted(() =>{
        loader.value = false
        if( import.meta.client && currentCarat.value !== null && window.affirm !== undefined ){
            nextTick(() => {
                window.affirm.ui.ready(() => {
                    window.affirm.ui.refresh();
                });
            });
        }
        skeleton.value = false
    })

</script>

<style scoped>
h1{
    font-style: normal;
    font-size: 32px;
    color: #212529;
    text-transform: capitalize;
}
.price_box h2 {
   font-size: 24px;
    color: #212529;
    margin: 0;
    line-height: 1.2;
    font-weight: 600;
    display: flex;
    align-items: center;
}
.price_box h2 span {
    color: #909090;
    font-weight: 400;
    font-size: 18px;
    text-decoration: line-through;
}
.select_button {
    background: var(--green);
    color: #fff;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.igi_block span {
    font-size: 12px;
    color: #606060;
    font-weight: 600;
}

.igi_block {
    background: #f5f5f5;
    display: flex;
    align-items: center;
    padding: 0 13px 0 8px;
    border-radius: 5px;
}
.price_igi {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
label{
    color: #353535;
    font-size: 14px;
    font-weight: 600;
}
.proceed_msg label {
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    color: #303030;
    display: block;
    padding-bottom: 8px;
}
.proceed_msg p {
    color: #606060;
    font-weight: 500;
}
.please_select .svg-head {
    height: 12px;
    width: 20px;
}
.please_select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    height: 44px;
    pointer-events: none;
    opacity: 0.5;
    border-radius: 8px;
}
.ship_date p {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
}
.ship_date p span {
    color: var(--green);
    font-weight: 600;
}
.quicker p {
    color: #606060;
}
.quicker p span {
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}
@media(max-width: 1100px){
    h1{
        font-size: 26px;
        line-height: normal;
    }
}
@media(max-width: 992px){
    .tooltip_text.tooltip_text_mod {
        margin-left: -150px;
    }
}

@media(max-width: 950px){
    h1 {
        font-size: 26px;
    }
    .price_box h2 {
        font-size: 26px;
    }
}
@media(max-width: 767px){
    .price_igi {
        width: 100%;
    }
    .select_btn_block {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
        padding: 13px;
        border-radius: 8px 8px 0 0;
        background: #fff;
        z-index: 9;
    }
    h1 {
        /* margin-top: 10%; */
        font-size: 24px;
    }
    .price_box h2 span {
        font-size: 16px;
    }
    
    .price_box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .price_box h2 {
        font-size: 20px;
    }
    .tooltip_text.tooltip_text_mod {
        margin-left: -120px;
    }
}
</style>